import './MobileDatePeriodSelect.scss';

import { func, string } from 'prop-types';
import React from 'react';
import {activityPageBeaconDatePickerEnabled} from 'services/FeatureFlags';
import DateRangeInputBeacon from "../Input/DateRangeInputBeacon";

const MobileDatePeriodSelect = ({
  fromDate,
  maxDate,
  minDate,
  toDate,
  toggleFromDate,
  toggleTimePeriod,
  toggleToDate,
  onChangeBeacon
}) => (
  <div className="mobile-select-group e2e-sort-by-select">
    {activityPageBeaconDatePickerEnabled() ? (
      <div className="mobile-select-dates">
        <DateRangeInputBeacon
          fromDate={fromDate}
          maxDate={maxDate}
          minDate={minDate}
          toDate={toDate}
          fromLabel={"From"}
          iosMobile={true}
          toLabel={"To"}
          hideLabels={true}
          customClasses={'beacon-date-picker'}
          goCTAClickFunction={onChangeBeacon}
          toggleFromDate={toggleFromDate}
          toggleTimePeriod={toggleTimePeriod}
          toggleToDate={toggleToDate}
          timePeriodLabel="View Time Period"
        />
      </div>
    ) : (
      <div className="mobile-select-dates">
        <input
          type="date"
          min={minDate}
          max={maxDate}
          value={fromDate}
          onChange={toggleFromDate}
          placeholder="MM/DD/YYYY"
        />
        <input
          type="date"
          min={minDate}
          max={maxDate}
          value={toDate}
          onChange={toggleToDate}
          placeholder="MM/DD/YYYY"
        />
      </div>
    )}
  </div>
);

MobileDatePeriodSelect.propTypes = {
  fromDate: string,
  maxDate: string,
  minDate: string,
  toDate: string,
  toggleFromDate: func,
  toggleTimePeriod: func,
  toggleToDate: func
};

export default MobileDatePeriodSelect;
